<template>
  <div class="comp-terms">
    <text-subpage page-type="termsOfUseCompensation" hide-breadcrumb />
  </div>
</template>

<script>
import Vue from 'vue'
import TextSubpage from '~brand-components/lufthansa/shared/text-subpage.vue'

export default Vue.extend({
  components: {
    TextSubpage,
  },
})
</script>

<style lang="scss" scoped>
.comp-terms::v-deep {
  h2 {
    margin-bottom: 54px;
  }

  h3 {
    @apply font-bold;

    margin-bottom: 27px;
  }

  p {
    margin-bottom: 27px;
  }

  a {
    @apply underline
  }
}
</style>
